define('tooltip-notifier',['tooltips', 'errors/client-error', 'errors/network-error'],
function (tooltips, ClientError, NetworkError) {
	var tooltip;

	function showError(targetElement, message, error) {
		error = convertAjaxError(error);

		var title = "Fehler";
		if (error && error.title) {
			title = error.title;
		}

		if (error && error.friendlyMessage) {
			message = sentenceify(message) + ' ' + error.friendlyMessage;
		}

		showTooltip(targetElement, message, title, {style: "error"});
	}

	function showSuccess(targetElement, message, title) {
		title = title || "Vorgang erfolgreich";
		showTooltip(targetElement, message, title, {style: "success"});
	}

	function showInfo(targetElement, message, title) {
		title = title || "Hinweis";
		showTooltip(targetElement, message, title, {style: "info"});
	}

	function showTooltip(targetElement, message, title, style) {
		// remove the old tooltip
		if (tooltip) {
			tooltip.hide();
		}

		tooltip = new tooltips.TimedHoverableOpentip(targetElement, message, title, style);
	}

	/**
	 * Makes sure that str ends with an interpunctation symbol
	 */
	function sentenceify(str) {
		str = str.trim();
		if (str.match(/\w$/)) {
			str = str + '.';
		}
		return str;
	}

	function convertAjaxError(xhr) {
		if (!xhr) {
			return;
		}

		if (!('readyState' in xhr)) {
			return xhr;
		}

		if (xhr.readyState === 0) {
			return new NetworkError("Bitte überprüfe deine Internetverbindung und versuche es erneut.");
		}

		if (xhr.status >= 400 && xhr.status < 500) {
			try {
				var json = JSON.parse(xhr.responseText);
				if (typeof json.error === 'string')
					return new ClientError(json.error);
			} catch(e) {
				return e;
			}
		}
	}

	return {
		showError: showError,
		showSuccess: showSuccess,
		showInfo: showInfo
	};
});

